import { ReactElement } from 'react';
import { Card, CardContent, CardActions, Box, Typography } from '@mui/material';
import { useRoutes, useAwsEffect } from '@localstack/services';
import { ProgressButton, Breadcrumbs, FirehoseStreamCreateForm } from '@localstack/ui';

import { DEFAULT_FIREHOSE_ROUTES } from '@localstack/constants';

import { CreateDeliveryStreamInput } from 'aws-sdk/clients/firehose';

import { FirehoseProps } from './types';

export const FirehoseStreamCreate = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_FIREHOSE_ROUTES,
}: FirehoseProps): ReactElement => {
  const { goto } = useRoutes();

  const { createDeliveryStream, isLoading } = useAwsEffect('Firehose', ['createDeliveryStream'], {
    revalidate: ['listDeliveryStreams', 'describeDeliveryStream'],
    clientOverrides,
  });

  const handleCreate = async (data: CreateDeliveryStreamInput) => {
    await createDeliveryStream(data);
    goto(routes.RESOURCES_FIREHOSE_STREAMS);
  };

  return (
    <Layout
      documentTitle="Data Firehose: Create Delivery Stream"
      title={
        <Box>
          <Typography variant="h4">Create Delivery Stream</Typography>
          <Breadcrumbs
            mappings={[
              ['Firehose', () => goto(routes.RESOURCES_FIREHOSE_STREAMS)],
              ['Delivery Streams', () => goto(routes.RESOURCES_FIREHOSE_STREAMS)],
              ['Create Delivery Stream', null],
            ]}
          />
        </Box>
      }
      actions={
        <ProgressButton type="submit" form="create" variant="outlined" color="primary" loading={isLoading}>
          Submit
        </ProgressButton>
      }
    >
      <Card>
        <CardContent>
          <FirehoseStreamCreateForm formId="create" loading={isLoading} onCreate={handleCreate} />
        </CardContent>
        <CardActions>
          <ProgressButton type="submit" form="create" variant="contained" color="primary" loading={isLoading}>
            Submit
          </ProgressButton>
        </CardActions>
      </Card>
    </Layout>
  );
};
